import { render, staticRenderFns } from "./ModalAddProduct.vue?vue&type=template&id=38505309&"
import script from "./ModalAddProduct.vue?vue&type=script&lang=js&"
export * from "./ModalAddProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports